import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=8df7cac0&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=8df7cac0&prod&scoped=true&lang=css"
import style1 from "./TaskList.vue?vue&type=style&index=1&id=8df7cac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df7cac0",
  null
  
)

export default component.exports